import { c as _c } from "react/compiler-runtime";
import { TrustpilotReview } from "@lib/generated/graphql";
import Image from "next/image";
import { FC } from "react";
type CustomerReviewsItemProps = {
  data: TrustpilotReview;
};
const CustomerReviewsItem: FC<CustomerReviewsItemProps> = t0 => {
  const $ = _c(19);
  const {
    data
  } = t0;
  const t1 = `https://de.trustpilot.com/reviews/${data.reviewId}`;
  let t2;
  if ($[0] !== data.title) {
    t2 = <span>{data.title}</span>;
    $[0] = data.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `/assets/img/trustpilot/stars-${data.score}.svg`;
  let t4;
  if ($[2] !== t3) {
    t4 = <Image src={t3} alt="Trustpilot Stars" height="23" width="112" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t4) {
    t5 = <a href={t1} target="_blank" rel="noreferrer noopener" className="flex font-medium justify-between items-center mb-2xs">{t2}{t4}</a>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const t6 = data.review || "";
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="text-justify mb-xs text-body-2" dangerouslySetInnerHTML={{
      __html: t6
    }} />;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `- ${data.author}`;
  let t9;
  if ($[10] !== t8) {
    t9 = <span>{t8}</span>;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a target="blank" rel="noopener noreferrer" href="https://de.trustpilot.com/review/justhome.com"><Image src="/assets/img/trustpilot-logo.svg" height="46" width="110" alt="Trustpilot Logo" /></a>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t9) {
    t11 = <div className="flex justify-between items-center text-body-2 mt-auto pt-3s">{t9}{t10}</div>;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t5 || $[17] !== t7) {
    t12 = <div className="p-m flex flex-col bg-neutral-0 rounded-m border border-neutral-50">{t5}{t7}{t11}</div>;
    $[15] = t11;
    $[16] = t5;
    $[17] = t7;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
export default CustomerReviewsItem;